export const ALARM_LOAD = 'ALARM_LOAD';
export const ALARM_LOAD_SUCCESS = 'ALARM_LOAD_SUCCESS';
export const ALARM_LOAD_ERROR = 'ALARM_LOAD_ERROR';

export const ALARMS_LOAD = 'ALARMS_LOAD';
export const ALARMS_LOAD_SUCCESS = 'ALARMS_LOAD_SUCCESS';
export const ALARMS_LOAD_ERROR = 'ALARMS_LOAD_ERROR';

export const ALARM_ADD = 'ALARM_ADD';
export const ALARM_ADD_SUCCESS = 'ALARM_ADD_SUCCESS';
export const ALARM_ADD_ERROR = 'ALARM_ADD_ERROR';

export const ALARMS_ADD = 'ALARMS_ADD';
export const ALARMS_ADD_SUCCESS = 'ALARMS_ADD_SUCCESS';
export const ALARMS_ADD_ERROR = 'ALARMS_ADD_ERROR';

export const ALARM_UPDATE = 'ALARM_UPDATE';
export const ALARM_UPDATE_SUCCESS = 'ALARM_UPDATE_SUCCESS';
export const ALARM_UPDATE_ERROR = 'ALARM_UPDATE_ERROR';

export const ALARMS_UPDATE = 'ALARMS_UPDATE';
export const ALARMS_UPDATE_SUCCESS = 'ALARMS_UPDATE_SUCCESS';
export const ALARMS_UPDATE_ERROR = 'ALARMS_UPDATE_ERROR';

export const ALARM_DELETE = 'ALARM_DELETE';
export const ALARM_DELETE_SUCCESS = 'ALARM_DELETE_SUCCESS';
export const ALARM_DELETE_ERROR = 'ALARM_DELETE_ERROR';

export const ALARMS_DELETE = 'ALARMS_DELETE';
export const ALARMS_DELETE_SUCCESS = 'ALARMS_DELETE_SUCCESS';
export const ALARMS_DELETE_ERROR = 'ALARMS_DELETE_ERROR';

export const ALARMS_AFTER_UPDATE = 'ALARMS_AFTER_UPDATE';